module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-color-picker"
  }, [_c('flexbox', _vm._l((_vm.colors), function(color) {
    return _c('flexbox-item', {
      key: color,
      staticClass: "vux-color-box"
    }, [_c('span', {
      staticClass: "vux-color-item",
      class: {
        'vux-color-white': color === '#fff' || color === '#fff', 'vux-color-picker-small': _vm.size === 'small', 'vux-color-picker-middle': _vm.size === 'middle'
      },
      style: ({
        borderRadius: _vm.width / 2 + 'px',
        backgroundColor: color,
        width: _vm.width + 'px',
        height: _vm.width + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.change(color)
        }
      }
    }, [(color === _vm.value) ? _c('icon', {
      staticClass: "vux-color-checked",
      style: ({
        lineHeight: _vm.width + 'px'
      }),
      attrs: {
        "type": "success-no-circle"
      }
    }) : _vm._e()], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3801184"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/color-picker/index.vue
// module id = 559
// module chunks = 4